// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-table[data-v-0b6708aa]{margin-bottom:0}", "",{"version":3,"sources":["webpack://./resources/components/tables/AffiliateRevenueTable.vue"],"names":[],"mappings":"AAIA,6BACE,eAHF","sourcesContent":["@import \"../../scss/variables/color\";\n@import \"../../scss/variables/container-max-widths\";\n\n\n.card-table {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
